import React from "react";
import Main from "../components/main";
import ComplianceComponent from "../components/compliance";

export default function ESafety() {
  return (
    <Main>
      <ComplianceComponent/>
    </Main>
  );
}
